// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../static/images/bottom.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footerBox {
  text-align: center;
  min-width: 1200px;
}
.footerBox-bg {
  background: linear-gradient(to right, #3157ea, #6d89f5);
  height: 243px;
}
.footerBox-bg div {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  height: 243px;
}
.footerBox-bottom {
  background: #333;
  height: 40px;
  line-height: 40px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}
.footerBox a {
  color: rgba(255, 255, 255, 0.7);
  padding-left: 20px;
}
.footerBox a:hover {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/index.less"],"names":[],"mappings":"AAAA;EAAW,kBAAA;EAAoB,iBAAA;AAG/B;AAFG;EAAK,uDAAA;EAAwD,aAAA;AAMhE;AANG;EACO,oEAAA;EAAiE,aAAA;AAS3E;AAPG;EAAS,gBAAA;EAAiB,YAAA;EAAa,iBAAA;EAAmB,+BAAA;EAA6B,eAAA;AAc1F;AAlBA;EAKK,+BAAA;EAA6B,kBAAA;AAiBlC;AAtBA;EAMW,WAAA;AAmBX","sourcesContent":[".footerBox{text-align: center; min-width:1200px;\n   &-bg{background:linear-gradient(to right, #3157ea, #6d89f5); height:243px; \n      div{background:url(../../static/images/bottom.jpg) no-repeat center; height:243px;}\n   }\n   &-bottom{background:#333; height:40px; line-height: 40px; color:rgba(255,255,255,0.7); font-size:12px;}\n   a{color:rgba(255,255,255,0.7); padding-left:20px;}\n   a:hover{color:#fff;}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
